<ng-container *ngIf="showAsTag">
    <div class="pill tag"
         [class.mobile]="isMobileDisplay"
         [matTooltip]="data.name ?? ''"
         [style.background-color]="data.colorHex"
         [style.color]="data.textColorHex">
        {{ data.name }}
    </div>
</ng-container>

<ng-container *ngIf="!showAsTag">
    <div class="pill chip"
         [style.background-color]="data.colorHex"
         [style.width.px]="chipSize"
         [style.height.px]="chipSize">
    </div>
    <div *ngIf="!hideText"
         class="pill text"
         [matTooltip]="data.name ?? ''">
        {{ data.name }}
    </div>
</ng-container>
